module.exports = __webpack_public_path__ + "img/oft_pc.4fe8831e.png";